const PROGRESS_UPDATE = 'PROGRESS_UPDATE';

export default PROGRESS_UPDATE;



// WEBPACK FOOTER //
// ./src/actions/progress/actionTypes.js